import * as React from "react";
import { Download } from "lucide-react";

import { Button } from "@/components/ui/button";

import ActionConfirmationModal, { ACTION_CONFIGS } from "../common/ActionConfirmationModal";
import JobsRepository from "../../repositories/JobsRepository";
import { ExportSourceLinksToCsvRequest } from "../../models/Jobs/JobRequest";

/**
 * Downloads a finished source link export after asking for a reason, wherever the export is listed.
 */
/*
 * Every download of this export is recorded, whoever makes it, so the prompt is not skipped for the assigned user or
 * an Admin the way it is for the other exports. The entry is written before the file is handed over, so a download
 * is on record even if the browser then blocks the new window.
 */
export const SourceLinkExportDownloadButton: React.FC<{ job: ExportSourceLinksToCsvRequest }> = ({ job }) => {
  // Built in the render body: JobsRepository calls useApi() when constructed, which is a hook.
  const jobsRepository = new JobsRepository();

  return (
    <ActionConfirmationModal
      actionConfig={ACTION_CONFIGS.DOWNLOAD_SOURCE_LINKS_EXPORT}
      onConfirm={async (reason) => {
        await jobsRepository.auditLogSourceLinksCsvExportDownload(job.id, reason);
        if (job.exportedCsvUrl) window.open(job.exportedCsvUrl, "_blank");
      }}
    >
      <Button
        variant="ghost"
        size="icon-sm"
        className="text-primary"
        aria-label="Download export"
        disabled={!job.exportedCsvUrl}
      >
        <Download className="size-4" />
      </Button>
    </ActionConfirmationModal>
  );
};

export default SourceLinkExportDownloadButton;
